import React from "react";
import {Button} from 'react-bootstrap';

function ActionCell({cell, handleJDResponse}) {

  return (
    <>
      <Button
        variant="outline-success"
        className="tbl-act-btn accept"
        onClick={() => handleJDResponse(cell.row.original, "Approved")}
        disabled={cell.row.original["STATUS"] !== "Pending"}
      >
        <i className="fi fi-rr-check"></i>
      </Button>
      <Button
        variant="outline-danger"
        className="tbl-act-btn reject"
        onClick={() => handleJDResponse(cell.row.original, "Cancelled")}
        disabled={cell.row.original["STATUS"] !== "Pending"}
      >
        <i className="fi fi-rr-cross"></i>
      </Button>
    </>
  );
}

export default ActionCell;
